import { combineReducers } from 'redux';
import note from './note.reducer';
import user_note from './user_note.reducer';

const noteReducer = combineReducers({
    note,
    user_note,
});

export default noteReducer;


// WEBPACK FOOTER //
// src/main/components/note/store/reducers/index.js